import type { ToastType } from '@/_components';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong' as const;
export const DEFAULT_INFO_MESSAGE = 'Updated' as const;
export const DEFAULT_SUCCESS_MESSAGE = 'Successfully updated' as const;

export const DEFFAULT_ERROR_MESSAGE: Record<ToastType, string> = {
  info: DEFAULT_INFO_MESSAGE,
  error: DEFAULT_ERROR_MESSAGE,
  success: DEFAULT_SUCCESS_MESSAGE,
};
